import React from "react";

const Page = ({children, label, icon}) => {

    return (
        <section className="content-wrapper mt-3 transition">
            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            {label &&
                                <div className="">
                                    <h2 className="text-uppercase fw-light"><i className={`${icon} text-theme`}/> {label}</h2>
                                 </div>
                            }
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Page
